import React, { createContext, ReactElement, ReactNode, useContext, useState } from 'react';

export enum BrandState {
  Audi = 'Audi',
  Vw = 'Vw',
}

interface BrandContextValue {
  brand: BrandState;
  setBrand: (brand: BrandState) => void;
}

export const BrandContext = createContext<BrandContextValue | undefined>(undefined);

export interface BrandProviderProps {
  initialBrand?: BrandState;
  children?: ReactNode;
}

export function BrandProvider({ initialBrand = BrandState.Vw, children }: BrandProviderProps): ReactElement {
  const [brand, setBrand] = useState<BrandState>(initialBrand);

  return <BrandContext.Provider value={{ brand, setBrand }}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandContextValue {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
}
